export const SET_SURVEYS = 'SET_SURVEYS';
export const ADD_SURVEYS = 'ADD_TODO';
export const UPDATE_SURVEY = 'UPDATE_TODO';
export const REMOVE_SURVEY = 'REMOVE_TODO';

export const setSurveys = surveys => ({
  type: SET_SURVEYS,
  surveys,
});